<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon
          >Modificar reprogramación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha inicio"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha fin"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-if="form.fecha_desde && form.fecha_hasta"
                  v-model="total_dias"
                  label="Días"
                  disabled
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      dias_a_programar: null,
      saldo_a_programar: null,
      id: null,
      total_dias: 0
    };
  },
  mounted() {
    this.verEstadoVacacion();

    this.$bus.$on("openDialogModificarReprogramacion", item => {
      this.form = item;
      (this.form.fecha_desde = this.form.fecha_desde
        .split("/")
        .reverse()
        .join("-")),
        (this.form.fecha_hasta = this.form.fecha_hasta
          .split("/")
          .reverse()
          .join("-")),
        this.calculaDiferenciaDias();
      this.dialog = true;
    });
  },

  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogModificarReprogramacion");
      this.dialog = false;
    },
    // Metodo para calcular los dias habiles entre las 2 fechas
    async calculaDiferenciaDias() {
      try {
        let res;
        if (this.form.fecha_desde && this.form.fecha_hasta) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select vacaciones.fn_obtiene_dias_habiles_entre_fechas('${this.form.fecha_desde}','${this.form.fecha_hasta}')"){
								respuesta
							}
							}
						`
          });
          let res2 = res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;
          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_funcionario = user.id_funcionario;
      let id_persona = user.id_persona;
      try {
        let res = await this.$service.graphql({
          query: `	
          query{
            vEstadoVacacions(id_persona: ${id_persona}){
              rows{
                nombre
                dias_saldo
                dias_asignados
                dias_utilizados
                dias_programados
                dias_cta_vacacion
                id
                id_estado
                id_persona
                nombre
                ingreso
                gestion_desde
                gestion_hasta
                cas
                estado
                dias_a_programar
                saldo_a_programar
              }
            }
          } 
        `
        });
        this.estado_vacacion = res.vEstadoVacacions.rows;
        this.saldo_a_programar = parseInt(
          this.estado_vacacion[0].saldo_a_programar
        );
        this.nombre = this.estado_vacacion[0].nombre;
        this.fecha_ingreso = this.estado_vacacion[0].ingreso;
        this.persona = this.estado_vacacion[0].id_persona;
        this.saldo = this.estado_vacacion[0].dias_saldo;
        this.dias_a_programar = this.estado_vacacion[0].dias_a_programar;
        this.id = this.estado_vacacion[0].id;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");
      let id_funcionario = user.id;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{runQuery(consulta:"select vacaciones.fn_actualiza_vacacion_programada(${this.form.id},${this.form.id_persona},'${this.form.fecha_desde}','${this.form.fecha_hasta}',${parseInt(this.total_dias)},${id_funcionario})"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_vacacion_programada;
          resps = respuesta.split("|");
          correcto = resps[0];
          if (correcto === "1") {
            this.$confirm("Modificación exitosa", () => {
              this.loading = false;
              this.close();
            });
          } else {
            this.$confirm(resps[1], () => {
              this.loading = false;
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_reprogramacion/dialogs/ModificarReprogramacion.vue